export enum MyProgressActiveTab {
  Overview = "overview",
  Courses = "courses",
  Units = "units",
  Badges = "badges",
  Certificates = "certificates",
  Timeline = "timeline",
}
